/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demogesellschaft16Inputs */

const en__field_enum_demogesellschaft16 = /** @type {(inputs: _Field_Enum_Demogesellschaft16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 - Gesellschaftswissenschaften`)
};

const de__field_enum_demogesellschaft16 = /** @type {(inputs: _Field_Enum_Demogesellschaft16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`03 - Gesellschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "03 - Gesellschaftswissenschaften" |
*
* @param {_Field_Enum_Demogesellschaft16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demogesellschaft16 = /** @type {((inputs?: _Field_Enum_Demogesellschaft16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demogesellschaft16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demogesellschaft16(inputs)
	return de__field_enum_demogesellschaft16(inputs)
});
export { _field_enum_demogesellschaft16 as "_field_enum_DEMOGESELLSCHAFT" }